import React from "react";
import {en} from "./date.i18n/en";

const DAY = 'day';
const MONTH = 'month';
const YEAR = 'year';

const LEVELS = [DAY,MONTH,YEAR];

export class Datepicker extends React.Component {

  static defaultProps = {
    parser: function (str) {
      const date = new Date(str);
      return isNaN(date) ? now() : date;
    },
    formatter: function (date) {
      return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    },
    lang:en,
    min: new Date(now().setFullYear(now().getFullYear() - 100)),
    max: new Date(now().setFullYear(now().getFullYear() + 100)),
    weekStartsMonday: false
  };

  constructor(props) {
    super(props);
    this.state = {level:DAY,currentDate:new Date(props.selectedDate||now())}
  }

  element;

  componentWillReceiveProps(newProps) {
    if (newProps.selectedDate !== this.props.selectedDate) {
      this.setState({currentDate:new Date(newProps.selectedDate),level:LEVELS[Math.max(LEVELS.indexOf(this.state.level)-1,0)]})
    }
  }

  setCurrentDatePlus = (n, type) => () => {
    const date = new Date(this.state.currentDate.getTime());
    switch (type) {
      case DAY:
        date.setDate(date.getDate() + n);
        break;
      case MONTH:
        date.setMonth(date.getMonth() + n);
        break;
      case YEAR:
        date.setFullYear(date.getFullYear() + n);
        break;
      default:break;
    }
    this.setState({currentDate:date})
  };

  up = () => this.setState({level:LEVELS[LEVELS.indexOf(this.state.level)+1]});


  keyDown = (e) => {
    const {level,currentDate} = this.state;
    const upDownSpacing = level === DAY ? 7 : 4;
    const keyMapper = {
      'ArrowLeft':-1,
      'ArrowRight':1,
      'ArrowUp':-upDownSpacing,
      'ArrowDown':upDownSpacing
    };
    if (keyMapper[e.key]) {
      e.preventDefault();
      this.setCurrentDatePlus(keyMapper[e.key],level)()
    }
    if (e.key === 'Enter') {
      e.preventDefault();
      this.props.onChange(currentDate);
    }
  };
  componentDidMount() {
    this.element.focus()
  }

  handleChange = (date) => {
    if (this.state.level===DAY) {
      this.props.toggle();
    }
    this.props.onChange(date)
  };

  prevent = (e) => e.stopPropagation();

  render() {
    const getView = () => {
      switch (this.state.level) {
        case DAY: return <Calendar {...this.props} {...this.state} handleChange={this.handleChange} changeCurrentDate={this.setCurrentDatePlus} up={this.up}/>;
        case MONTH: return <Months {...this.props} {...this.state} handleChange={this.handleChange} changeCurrentDate={this.setCurrentDatePlus} up={this.up}/>;
        case YEAR: return <Years {...this.props} {...this.state} handleChange={this.handleChange} changeCurrentDate={this.setCurrentDatePlus} />;
        default:return null;
      }
    };
    // const {lang,weekStartsMonday,max,min} = this.props;
    // const {currentDate,selectedDate} = this.state;
    return (<div onClick={this.prevent} ref={e=>this.element = e} tabIndex={-1} onKeyDown={this.keyDown} >
      {getView()}
    </div>)

  }
}
function now() {
  const dt = new Date();
  dt.setHours(0, 0, 0, 0);
  return dt;
}
function inRange(context, date) {
  return context.min <= date && context.max >= date;
}
const mapDays = (currentDate, dayOffset, fn) => {
  const month = [];
  const iter = new Date(currentDate);
  iter.setDate(1);
  const startDay = dayOffset + iter.getDate() - iter.getDay();
  iter.setDate(startDay);
  for (let week = 0;week<6;week++) {
    const weekdays = [];
    for (let day = week*7;day<(week*7)+7;day++) {
      weekdays.push(fn(iter,startDay+day));
      iter.setDate(iter.getDate() + 1);
    }
    month.push({days:weekdays,time:iter.getTime()})
  }
  return month;
};
const Calendar = ({lang:{months,daysMin},max,min,selectedDate,currentDate,weekStartsMonday,changeCurrentDate,handleChange,up}) => {
  const currentMonth = currentDate.getMonth();
  const dayOffset = weekStartsMonday ? 1 : 0;
  const today = now().getTime();
  const handleDateChange = (e) => {
    const date = new Date(currentDate);
    handleChange(new Date(date.setDate(e.currentTarget.getAttribute("data-day"))))
  };
  return (
    <div className="datepicker">
      <div className="datepicker-header">
        <a className="navigation-button" onClick={changeCurrentDate(-1,MONTH)}><span className="icon icon-arrow-left-line"/></a>
        <a className="title" onClick={up}>{months[currentMonth]} {currentDate.getFullYear()}</a>
        <a className="navigation-button" onClick={changeCurrentDate(1,MONTH)}><span className="icon icon-arrow-right-line"/></a>
      </div>
      <div className="datepicker-content">
        <div className="weeks-header"> {daysMin.map((day,i)=><span key={i}>{daysMin[(i+dayOffset)%daysMin.length]}</span>)}</div>
        {mapDays(currentDate, dayOffset,(date,day) => {
          const isNotInMonth = date.getMonth() !== currentMonth;
          const isDisabled = !inRange({max,min}, date);
          const isToday = date.getTime() === today;
          const className = 'day' +
            (isNotInMonth ? ' edge' : '') +
            (date.getTime() === currentDate.getTime() ? ' current' : '') +
            (date.getTime() === selectedDate.getTime() ? ' selected' : '') +
            (isDisabled ? ' disabled' : '') +
            (isToday ? ' today' : '');
          return  <a key={date.getTime()} onClick={handleDateChange} className={className} data-day={day}>{date.getDate()}</a>;
        }).map(({days,time}) => <div className="week" key={time}>{days}</div>)}
      </div>
    </div>
  );
};

const Months = ({lang:{monthsShort},currentDate,selectedDate,changeCurrentDate,handleChange,up}) => {
  const currentMonth = currentDate.getMonth();
  const sameYear = currentDate.getFullYear() === selectedDate.getFullYear();
  const selectedMonth = sameYear ? currentDate.getMonth() : undefined;
  const handleMonthChange = (e) => {
    const date = new Date(currentDate);
    handleChange(new Date(date.setMonth(e.currentTarget.getAttribute("data-month"))))
  };
  console.log(monthsShort.map((month,i)=> {
    const className = "dp-month"+(currentMonth===i?' dp-current':'')+(selectedMonth===i?' dp-selected':'');
    return <a onClick={handleMonthChange} key={month} data-month={i} className={className}>{month}</a>
  }).reduce(groupBy(3,'month'),[]))
  return (
    <div className="datepicker">
      <div className="datepicker-header">
        <a className="navigation-button" onClick={changeCurrentDate(1,YEAR)}><span className="icon icon-arrow-left-line"/></a>
        <a className="title" onClick={up}>{currentDate.getFullYear()}</a>
        <a className="navigation-button" onClick={changeCurrentDate(-1,YEAR)}><span className="icon icon-arrow-right-line"/></a>
      </div>
      <div className="datepicker-content">
        {monthsShort.map((month,i)=> {
          const className = "month"+(currentMonth===i?' current':'')+(selectedMonth===i?' selected':'');
          return <a onClick={handleMonthChange} key={month} data-month={i} className={className}>{month}</a>
        }).reduce(groupBy(3,'month'),[]).map(({i,month}) => {
          return <div key={i}>{month}</div>
        })}
      </div>
    </div>
  )
};

function groupBy(quant,key) {
  return (acc,value,i)=>{
    return (i%quant===0) ?
      [...acc,{i,[key]:[value]}] :
      [
        ...acc.slice(0,parseInt(i/quant,10)),
        {...acc[parseInt(i/quant,10)],[key]:[...acc[parseInt(i/quant,10)][key],value]}
      ]
  }
}

// Given the specified context, produces an HTML string
// representing months of the year.

function mapYears(currentDate, fn) {
  const result = [];
  const year = currentDate.getFullYear();
  for (let i = 0; i < (4*3); i++) {
    result.push(fn(year - (year%10) - 1 + i, i<1 || i>10));
  }
  return result;
}

const Years = ({selectedDate,currentDate,changeCurrentDate,handleChange}) => {
  const currentYear = currentDate.getFullYear();
  const selectedYear = selectedDate.getFullYear();
  const handleYearChange = (e) => {
    const date = new Date(currentDate);
    handleChange(new Date(date.setFullYear(e.currentTarget.getAttribute("data-year"))))
  };
  return (
    <div className="datepicker">
      <div className="datepicker-header">
        <a className="navigation-button" onClick={changeCurrentDate(-10,YEAR)}><span className="icon icon-arrow-left-line"/></a>
        <a className="title">{currentYear-(currentYear%10)}-{currentYear-(currentYear%10)+9}</a>
        <a className="navigation-button" onClick={changeCurrentDate(10,YEAR)}><span className="icon icon-arrow-right-line"/></a>
      </div>
      <div className="datepicker-content">
        {mapYears(currentDate, function (year,outside) {
          const className = 'year' +
            (year === currentYear ? ' current' : '') +
            (year === selectedYear ? ' selected' : '') +
            (outside ? ' edge':'') ;
          return (<a key={year} onClick={handleYearChange} data-year={year} className={className}>{year}</a>);
        }).reduce(groupBy(3,'year'),[]).map(({year,i})=> <div key={i}>{year}</div>)}
      </div>
    </div>
  );
};
const escapedValidParts = /(^|[^\\])(dd?|DD?|mm?|LL?|hh?|MM?|yy(?:yy)?)/g;
const validParts = /(dd?|DD?|mm?|LL?|hh?|MM?|yy(?:yy)?)$/;
export function formatDate(date, language, format) {
  if (!date || !date.getTime())
    return '';
  const val = {
    m: date.getMinutes(),
    s: date.getSeconds(),
    h: date.getHours(),
    d: date.getDate(),
    D: (language.daysShort||[])[date.getDay()],
    DD: (language.days || [])[date.getDay()],
    M: date.getMonth() + 1,
    L: (language.monthsShort||[])[date.getMonth()],
    LL: (language.months||[])[date.getMonth()],
    yy: date.getFullYear().toString().substring(2),
    yyyy: date.getFullYear()
  };
  const lessThan10 = (v) => (v < 10 ? '0' : '') + v;
  val.dd = lessThan10(val.d);
  val.MM = lessThan10(val.M);
  val.hh = lessThan10(val.h);
  val.mm = lessThan10(val.m);
  val.ss = lessThan10(val.s);
  const separators = (format || language.format).replace(escapedValidParts, '\0').split('\0');
  const parts = (format || language.format).match(escapedValidParts);
  const formattedDate = parts.reduce((acc,part)=>acc.concat(separators.length?[separators.shift()]:[],part.replace(validParts,""),val[part.match(validParts)[0]]) ,[]);
  return formattedDate.join('').replace(/\\([dDmLhMy])/g,'$1');
}